

























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ExamSelect from '@/components/select/ExamSelect.vue'
import { Nilable } from '@/models/helpers/common'
import { alert, notify } from '@/utils/notification'
import { validNotifyExam } from '@/service/exam'
@Component({
  components: { ExamSelect }
})
export default class downloadNotify extends Vue {
  active = 0
  loading = false
  form = {
    exam: null as Nilable<string>
  }
  url = ''
  baseUrl = process.env.VUE_APP_BASE_API

  get isMinStep() {
    return this.active === 0
  }

  get isMaxStep() {
    return this.active === 1
  }

  handleLast() {
    if (!this.isMinStep) this.active -= 1
  }

  async handleNext() {
    var res = await validNotifyExam(this.form.exam as string)
    if (!res) return
    if (!this.isMaxStep) {
      this.active += 1
      this.url = `${this.baseUrl}/exam/${this.form.exam}/invigilator/downLoad/doc`
    }
  }
}
